<template>
  <div class="dashboard-card">
    <div class="card-header">
      <awesomeIcon icon="paper-plane"/> Uitkeringen per jaar (Alleen zichtbaar voor admins)
    </div>
    <div class="card-graph">
      <GChart
        :settings="{ packages: ['corechart'], language: 'nl-nl' }"
        :data="rows"
        :options="options"
        :events="chartEvents"
        type="ComboChart"
      />
    </div>
    <div id="payout-tooltip" />
  </div>
</template>

<script>
import { groupBy, sumBy, filter } from 'lodash-es';

export default {
  name: 'PayoutWidget',
  data() {
    return {
      options: {
        tooltip: {
          trigger: 'none',
        },
        backgroundColor: { fill: 'transparent' },
        height: 300,
        colors: JSON.parse(JSON.stringify(this.$store.state.colorScheme)),
        legend: { position: 'top' },
        pointSize: 0,
        chartArea: {
          left: 65,
          top: 25,
          bottom: 35,
          right: 20,
          width: '100%',
          height: '100%',
        },
        hAxis: {
          title: 'Uitkeringsjaar',
          gridlines: { color: '#eee' },
          textStyle: { fontSize: 13 },
        },
        vAxis: {
          gridlines: { color: '#eee' },
          textStyle: { fontSize: 13 },
        },
        isStacked: true,
        series: {
          0: {
            type: 'bars',
            color: '#000066',
          },
          1: {
            type: 'bars',
            color: '#6c0',
            annotations: {
              stem: {
                color: 'green',
              },
              textStyle: {
                color: 'black',
                auraColor: '#fff',
              },
              stemLength: 30,
            },
          },
        },
        annotations: {
          stem: {
            color: 'black',
          },
          stemLength: 200,
        },
      },
      chartEvents: {
        onmouseover: this.setTooltipContent,
        onmouseout: () => { this.setTooltipContent(null); },
      },
      columns: [
        {
          type: 'string',
          label: 'Datum',
        },
        {
          type: 'number',
          label: 'Uitgekeerd',
        },
        {
          type: 'number',
          label: 'Verwachte uitkering',
        },
        {
          type: 'boolean',
          role: 'certainty',
        },
      ],
    };
  },
  computed: {
    rows() {
      return [this.columns].concat(this.getRows());
    },
  },
  methods: {
    getRows() {
      const cashflowArray = [];
      if (this.$parent.payout && this.$parent.payout.cashflow.length) {
        const transactions = filter(
          this.$parent.mutations,
          (obj) => !obj.storno
            && (obj.asset_name === 'Uitkering' || obj.asset_name === 'Loonbelasting' || obj.asset_name === 'Rekening courant'),
        );
        const payoutDate = new Date(this.$parent.payout.cashflow[0].fixedDate);
        const cashflow = groupBy(this.$parent.payout.cashflow, (o) => Math.floor(
          (new Date(o.fixedDate) - payoutDate) / 1000 / 365 / 24 / 60 / 60,
        ));
        const trans = groupBy(transactions, (o) => Math.floor(
          (new Date(o.date) - payoutDate) / 1000 / 365 / 24 / 60 / 60,
        ));
        for (let i = 0; i < Object.values(cashflow).length; i += 1) {
          cashflowArray.push(
            [
              i + 1,
              0,
              Number(
                sumBy(cashflow[i], (o) => Number(o.payout)),
                true,
              ),
              false,
            ],
          );
        }
        for (let i = 0; i < Object.values(trans).length; i += 1) {
          for (let j = 0; j < cashflowArray.length; j += 1) {
            if (cashflowArray[j][0] === i + 1) {
              cashflowArray[j][2] = Math.max(
                0,
                cashflowArray[j][2] - Number(sumBy(trans[i], (o) => o.total)),
              );
              cashflowArray[j][1] = Number(sumBy(trans[i], (o) => o.total));
            }
          }
        }
      }
      return cashflowArray;
    },
    setTooltipContent(object) {
      const tooltip = document.getElementById('payout-tooltip');
      if (object !== null) {
        tooltip.style.display = 'block';
        tooltip.innerHTML = `
        <b>
          Jaar ${this.rows[object.row + 1][0]}:
          Uitgekeerd: &euro;&nbsp;${this.formatPrice(this.rows[object.row + 1][1], true)},-,
          ${this.rows[object.row + 1][2] > 0 ? `Verwachte uitkering: &euro;&nbsp;${this.formatPrice(this.rows[object.row + 1][2], true)},-` : ''}
        </b>`;
      } else {
        tooltip.style.display = 'none';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.card-graph {
    padding-bottom: 10px;
    min-height: 300px;
}
#payout-tooltip {
    padding: 10px 20px;
    background-color: #fcf8e3;
    color: #8a6d3b;
    display: block;
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    display: none;
    pointer-events: none;
    border-radius: $br;
}
</style>
